var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFastDelivery = function SvgFastDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M50.482 44.356c-2.541 4.308-7.6 5.718-11.197 3.582-3.599-2.137-4.8-7.264-2.258-11.573 2.541-4.308 7.599-5.718 11.197-3.582 3.599 2.137 4.8 7.264 2.258 11.573ZM19.978 44.356c-2.541 4.308-7.599 5.718-11.197 3.582-3.599-2.137-4.8-7.264-2.258-11.573 2.541-4.308 7.6-5.718 11.197-3.582 3.599 2.137 4.8 7.264 2.258 11.573Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 2.727,
    d: "M21.262 36.684H36.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 3,
    d: "M5.457 36.685a3.259 3.259 0 0 1-3.186-3.947L4.795 21.06A3.882 3.882 0 0 1 8.589 18c1.51 0 2.884-.876 3.52-2.245l2.201-4.732a5.454 5.454 0 0 1 4.946-3.155h21.085a5.454 5.454 0 0 1 5.326 4.275l.35 1.582a5.454 5.454 0 0 0 5.326 4.275h1.583c3.425 0 6.003 3.12 5.357 6.484l-1.507 7.84a5.376 5.376 0 0 1-5.28 4.362"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C32",
    d: "M31.801 48h11.4v2.4h-11.4zM1.199 48h11.4v2.4h-11.4zM31 20.75a.5.5 0 0 0 .487.614h3.468a.5.5 0 0 1 .39.813l-6.544 8.12c-.334.414-.997.09-.877-.427L29 25.25a.5.5 0 0 0-.487-.614h-3.468a.5.5 0 0 1-.39-.813l6.544-8.12c.334-.414.997-.09.877.427L31 20.75Z"
  })));
};
export default SvgFastDelivery;